<template>
  <div class="px-4 px-lg-5 mx-lg-5">
    <slot />
  </div>
</template>
